import "./styles.scss";

import Dialog from "@material-ui/core/Dialog";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { MdError, MdCheckCircle } from "react-icons/md";
import { useCallback, useState, useEffect } from "react";

import { passwordValidator } from "../../utils/utils";
import { encryptValue } from "../../utils/fieldEncrypt";
import { updatePasswordUser } from "../../store/middleware";

function ModalChangePassword({ id, showModal, setShowModal }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.userReducer);

  const isManager = user?.role === "companyManager" || user?.role === "customerService";

  const [invalidPass, setInvalidPassword] = useState([
    { id: 1, message: "INVALID_PASS1", status: null },
    { id: 2, message: "INVALID_PASS2", status: null },
    { id: 3, message: "INVALID_PASS3", status: null },
    { id: 4, message: "INVALID_PASS4", status: null },
    { id: 5, message: "INVALID_PASS5", status: null },
  ]);
  const [password, setPassword] = useState(!isManager ? "" : "lingo@123");
  const [passwordConfirmation, setPasswordConfirmation] = useState(!isManager ? "" : "lingo@123");

  const closeModal = () => setShowModal(false);

  const submitPassword = (e) => {
    e.preventDefault();

    if (invalidPass.find((item) => item.status === null)) {
      const message = invalidPass.find((item) => item.status === null).message;
      alert(t(message));
      return false;
    }

    let formData = {
      id: Number(id),
      userPassword: { password: encryptValue(password) },
    };

    dispatch(updatePasswordUser(formData))
      .then((resp) => {
        if (resp !== 200) return alert("An error occurred, please try again later");
        alert(t("VALID_FORM_DESCRIPTION"));

        setPassword("");
        setPasswordConfirmation("");
        closeModal();
      })
      .catch(() => {
        alert("The password cannot be changed.");
        closeModal();
      });
  };

  const checkPassword = useCallback(
    async (e, type) => {
      if (type === "password") setPassword(e.target.value);
      else if (type === "confirmation") setPasswordConfirmation(e.target.value);

      setInvalidPassword(passwordValidator(password, passwordConfirmation));
    },
    [password, passwordConfirmation],
  );

  useEffect(() => {
    if (password) checkPassword();
    // eslint-disable-next-line
  }, [password, passwordConfirmation, checkPassword]);

  return (
    <Dialog
      open={showModal}
      onClose={closeModal}
      className="modalChangePassword"
      classes={"modalChangePassword"}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <div className="containerChangePassword">
        <h3 className="title">{t("CHANGE_PASSWORD_TITLE")}</h3>

        <form className="contentChangePassword">
          <div className="description">
            <p>{t("CHANGE_PASSWORD_DESCRIPTION")}</p>
          </div>

          <div className="wrapperInputs">
            <div className="items">
              <label htmlFor="password">{t("PASSWORD")}</label>
            </div>
            <input
              type="text"
              minLength={6}
              name="password"
              value={password}
              placeholder={t("PASS_PLACEHOLDER")}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>

          <div className="wrapperInputs">
            <div className="items">
              <label htmlFor="passwordConfirmation">{t("CHECK_PASS")}</label>
            </div>
            <input
              type="text"
              minLength={6}
              name="passwordConfirmation"
              value={passwordConfirmation}
              pattern="(?=.*\d)(?=.*[a-z]).{6,}"
              placeholder={t("CHECK_PASS_PLACEHOLDER")}
              onChange={(e) => setPasswordConfirmation(e.target.value)}
            />
          </div>

          <div className="wrapperInvalidPassword">
            {invalidPass &&
              invalidPass.map((message, index) =>
                message.status === null || message.status === false ? (
                  <div key={index}>
                    <MdError size={16} color="#979797" />
                    <p>
                      {t(message.message)} {message.id === 4 && "Ex: @#!$%^&*()-"}
                    </p>
                  </div>
                ) : (
                  <div key={index}>
                    <MdCheckCircle size={16} color="#3cacfc" />
                    <p style={{ color: "#3cacfc" }}>
                      {t(message.message)} {message.id === 4 && "Ex: @#!$%^&*()-"}
                    </p>
                  </div>
                ),
              )}
          </div>
        </form>

        <div className="footer">
          <button className="buttonModalBack" onClick={() => setShowModal(false)}>
            {t("CANCEL")}
          </button>
          <button className="buttonModalSave" onClick={submitPassword}>
            {t("CHANGE_PASSWORD_TITLE")}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default ModalChangePassword;
